'use client';

import { motion } from 'framer-motion';

import { PropsWithChildren } from 'react';

import { useBreakpoint } from '@/lib/style/hooks';

interface SidebarTransitionProps extends PropsWithChildren {
  noEntry?: boolean;
}

const SidebarTransition = ({
  children,
  noEntry = false,
}: SidebarTransitionProps) => {
  const isDesktop = useBreakpoint('md');

  if (!isDesktop) {
    return <div className="flex flex-col gap-y-8">{children}</div>;
  }

  const sidebarStyle = 'flex h-full flex-col justify-center gap-y-10 py-22';

  if (noEntry) {
    return <div className={sidebarStyle}>{children}</div>;
  }

  return (
    <motion.div
      initial={{ transform: 'translateX(25%)', opacity: 0 }}
      animate={{ transform: 'translateX(0)', opacity: 1 }}
      className={sidebarStyle}
    >
      {children}
    </motion.div>
  );
};

export default SidebarTransition;
